import {createContext} from 'react';

const CurrentRoutesContext = createContext();

export default CurrentRoutesContext;
